export const isExpired = (jwtToken: any) => {
  if (!jwtToken) {
    return true;
  }
  const ts = new Date().getTime();
  const delta = 10 * 60 * 1000; // 10 minutes
  return jwtToken.exp * 1000 <= ts + delta;
};

export const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const getToken = (): string | null => localStorage.getItem("user");

export const deleteToken = () => {
  localStorage.clear();
};
